import React from 'react';
import PortalPmsSettings from './PortalPmsSettings';

export default function PortalIntegrations() {
  return <PortalPmsSettings />;
}
